import { RuleType } from "@certa/studio-core/src/constants/rules.constants";

const RuleTypesToSkipTargetFieldDeletion = [
  RuleType.RelatedProcessDataInheritance,
  RuleType.ReadOnlyFieldConstraints
];

/**
 * Removed target_field and target_stepdef attribute from rule if not required
 */
export const cleanRawRules = (rawRules: any, ruleType: RuleType) => {
  if (!rawRules) return rawRules;
  Object.keys(rawRules).forEach((ruleKey: string) => {
    if (!RuleTypesToSkipTargetFieldDeletion.includes(ruleType)) {
      delete rawRules[ruleKey].target_field;
    }
    delete rawRules[ruleKey].target_stepdef;
  });
  return rawRules;
};
